/* globals jQuery, BHM */

import setupCarousel from './theme/carousel';
import makeTweets from './theme/twitter';

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Markup Tweaks
	// =========================

	$( '.wp-block-image img' ).wrap( '<div class="wp-block-image__wrapper"></div>' );

	$( '.bhm-wrapper' ).each( function() {
		$( this ).toggleClass( 'precedes-wrapper', $( this ).next().hasClass( 'bhm-wrapper' ) );
	} );

	$( 'a[href$=".jpg"], a[href$=".jpg"], a[href$=".png"]' ).attr( 'target', '_blank' ).attr( 'download', '' );

	// =========================
	// ! Modals
	// =========================

	$( 'a[href^="#"]' ).click( function( e ) {
		const target = $( this ).attr( 'href' );
		if ( target.length > 0 && $( target ).hasClass( 'js-modal' ) ) {
			e.preventDefault();
			$( target ).addClass( 'in' ).scrollTop( 0 );
		}
	} );

	$( '.js-modal-close' ).click( function() {
		$( this ).parents( '.js-modal' ).removeClass( 'in' );
	} );

	// =========================
	// ! Toggle Buttons
	// =========================

	$( '.toggle[href^="#"], [rel="toggle"], [data-toggle]' ).click( function( e ) {
		if ( this.tagName.toLowerCase() === 'a' ) {
			e.preventDefault();
		}

		const target = $( this ).data( 'toggle' ) || $( this ).attr( 'href' ).replace( '#', '' );
		const $toggles = $( `a[href="#${ target }"], [data-toggle="${ target }"]` );

		const className = `show-${ target }`;

		if ( $body.hasClass( className ) ) {
			$body.removeClass( className ).trigger( `toggle:${ target }:off` );
			$toggles.removeClass( 'is-active' );
		} else {
			$body.addClass( className ).trigger( `toggle:${ target }:on` );
			$toggles.addClass( 'is-active' );
		}
	} );

	// =========================
	// ! Module Tab Stuff
	// =========================

	$( '.bhm-module' ).each( function() {
		const $navItems = $( this ).find( '.bhm-module__nav a' );
		const $tabs = $( this ).find( '.bhm-module__tab' );

		$navItems.first().addClass( 'is-current' );
		$tabs.hide().first().show().addClass( 'is-current' );

		$navItems.click( function( e ) {
			e.preventDefault();
			if ( $( this ).hasClass( 'is-current' ) ) {
				return;
			}

			$navItems.removeClass( 'is-current' );
			$( this ).addClass( 'is-current' );

			const target = $( this ).attr( 'href' );
			$tabs.filter( '.is-current' ).fadeOut( 200, function() {
				$( this ).removeClass( 'is-current' );
				$tabs.filter( target ).fadeIn().addClass( 'is-current' );
			} );
		} );
	} );

	// =========================
	// ! Navbar Mobile Handling
	// =========================

	$( '.bhm-navbar__items-wrap' ).click( function() {
		$( this ).toggleClass( 'is-open' );
	} );

	// =========================
	// ! Carousels
	// =========================

	$( '.js-carousel' ).each( function() {
		setupCarousel( this );
	} );

	// =========================
	// ! Twitter Feed Handling
	// =========================

	$( '.js-twitter-feed' ).each( function() {
		const $feed = $( this );
		const $wrapper = $feed.find( '.js-tweets' );

		const template = $feed.find( '.js-tweet-template' ).html();

		$.get( BHM.twitter_feed_url, tweets => {
			$wrapper.append( makeTweets( tweets, template ) );
			setupCarousel( this );
		}, 'json' );
	} );

	// =========================
	// ! Input Placeholder Hack
	// =========================

	$( '.search-bar input' ).focus( function() {
		if ( this.value === '' ) {
			$( this ).val( $( this ).data( 'value' ) );
		}
	} ).on( 'input blur', function() {
		$( this ).attr( 'placeholder', this.value ? `Looking for \u201C${ this.value }\u201D` : 'Search\u2026' );
	} ).blur( function() {
		$( this ).data( 'value', this.value ).val( null );
	} ).trigger( 'blur' );

	// =========================
	// ! VH Hack
	// =========================

	const pixelRatio = window.innerWidth / document.documentElement.clientWidth;

	function setVH() {
		const vh = ( window.innerHeight / pixelRatio ) * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Popup Handling
	// =========================

	const popup = document.getElementById( 'popup' );
	if ( typeof window.localStorage !== 'undefined' && popup ) {
		const seen = localStorage.getItem( 'seenPopup' );
		const uid = popup.dataset.uid;

		if ( seen !== uid ) {
			$( popup ).addClass( 'in' );
			localStorage.setItem( 'seenPopup', uid );
		}
	}
} );
